module.exports = __webpack_public_path__ + "static/king-197e6f9245b34c6869520c666116d011.png";